import Image from '@atlaskit/image';
import buttonAnatomyLight from "../../../../../../packages/design-system/button/constellation/index/images/button-anatomy-light.png";
import buttonAnatomyDark from "../../../../../../packages/design-system/button/constellation/index/images/button-anatomy-dark.png";
import buttonPrimaryDoLight from "../../../../../../packages/design-system/button/constellation/index/images/button-primary-do-light.png";
import buttonPrimaryDoDark from "../../../../../../packages/design-system/button/constellation/index/images/button-primary-do-dark.png";
import buttonPrimaryDontLight from "../../../../../../packages/design-system/button/constellation/index/images/button-primary-dont-light.png";
import buttonPrimaryDontDark from "../../../../../../packages/design-system/button/constellation/index/images/button-primary-dont-dark.png";
import buttonDisableDoLight from "../../../../../../packages/design-system/button/constellation/index/images/button-disable-do-light.png";
import buttonDisableDoDark from "../../../../../../packages/design-system/button/constellation/index/images/button-disable-do-dark.png";
import buttonDisableDontLight from "../../../../../../packages/design-system/button/constellation/index/images/button-disable-dont-light.png";
import buttonDisableDontDark from "../../../../../../packages/design-system/button/constellation/index/images/button-disable-dont-dark.png";
import buttonConciseDoLight from "../../../../../../packages/design-system/button/constellation/index/images/button-concise-do-light.png";
import buttonConciseDoDark from "../../../../../../packages/design-system/button/constellation/index/images/button-concise-do-dark.png";
import buttonConciseDontLight from "../../../../../../packages/design-system/button/constellation/index/images/button-concise-dont-light.png";
import buttonConciseDontDark from "../../../../../../packages/design-system/button/constellation/index/images/button-concise-dont-dark.png";
import buttonCapitalizationDoLight from "../../../../../../packages/design-system/button/constellation/index/images/button-capitalization-do-light.png";
import buttonCapitalizationDoDark from "../../../../../../packages/design-system/button/constellation/index/images/button-capitalization-do-dark.png";
import buttonCapitalizationDontLight from "../../../../../../packages/design-system/button/constellation/index/images/button-capitalization-dont-light.png";
import buttonCapitalizationDontDark from "../../../../../../packages/design-system/button/constellation/index/images/button-capitalization-dont-dark.png";
import buttonActionDoLight from "../../../../../../packages/design-system/button/constellation/index/images/button-action-do-light.png";
import buttonActionDoDark from "../../../../../../packages/design-system/button/constellation/index/images/button-action-do-dark.png";
import buttonActionDontLight from "../../../../../../packages/design-system/button/constellation/index/images/button-action-dont-light.png";
import buttonActionDontDark from "../../../../../../packages/design-system/button/constellation/index/images/button-action-dont-dark.png";
import buttonLabelDoLight from "../../../../../../packages/design-system/button/constellation/index/images/button-label-do-light.png";
import buttonLabelDoDark from "../../../../../../packages/design-system/button/constellation/index/images/button-label-do-dark.png";
import buttonLabelDontLight from "../../../../../../packages/design-system/button/constellation/index/images/button-label-dont-light.png";
import buttonLabelDontDark from "../../../../../../packages/design-system/button/constellation/index/images/button-label-dont-dark.png";
import * as React from 'react';
export default {
  Image,
  buttonAnatomyLight,
  buttonAnatomyDark,
  buttonPrimaryDoLight,
  buttonPrimaryDoDark,
  buttonPrimaryDontLight,
  buttonPrimaryDontDark,
  buttonDisableDoLight,
  buttonDisableDoDark,
  buttonDisableDontLight,
  buttonDisableDontDark,
  buttonConciseDoLight,
  buttonConciseDoDark,
  buttonConciseDontLight,
  buttonConciseDontDark,
  buttonCapitalizationDoLight,
  buttonCapitalizationDoDark,
  buttonCapitalizationDontLight,
  buttonCapitalizationDontDark,
  buttonActionDoLight,
  buttonActionDoDark,
  buttonActionDontLight,
  buttonActionDontDark,
  buttonLabelDoLight,
  buttonLabelDoDark,
  buttonLabelDontLight,
  buttonLabelDontDark,
  React
};